import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { CDS_ZINDEX, Colors } from '@revenuemarket/cds';
import { tokens } from '@revenuemarket/vds';

export const FloatingPanelContainer = styled.div`
  position: fixed;
  border-radius: 16px;
  width: 360px;
  right: 24px !important;
  bottom: 80px !important;
  background-color: ${Colors.white};
  box-shadow: ${tokens.shadow.v2_l5};
  z-index: 999;
  overflow: hidden;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 20px;
`;

export const ListHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin: 0 20px 12px;
  padding: 12px 16px;
  background-color: ${Colors.blue600};
  border-radius: 12px;
`;

export const ListWrapper = styled.div`
  max-height: 320px;
  overflow-y: auto;
  padding: 0 20px 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ListItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ListItemTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ListItemLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ListItemRight = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ProgressBarWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 6px;
  background-color: ${Colors.grayOpacity12};
  border-radius: 3px;
  overflow: hidden;
`;

export const ProgressBarFill = styled.div<{
  progress: number;
  status: 'success' | 'error' | 'inProgress' | 'notConnected';
}>`
  width: ${({ progress }) => progress}%;
  height: 100%;
  background-color: ${({ status }) => {
    switch (status) {
      case 'success':
        return Colors.green400;
      case 'error':
        return Colors.red500;
      case 'inProgress':
        return Colors.blue600;
      case 'notConnected':
        return Colors.gray300;
      default:
        return Colors.blue600;
    }
  }};
  border-radius: 3px;
`;

const shimmerSlide = keyframes`
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(400%);
  }
`;

export const ProgressBarShimmer = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 25%;
  height: 100%;
  background: linear-gradient(to right, transparent, rgba(255, 255, 255, 0.4), transparent);
  animation: ${shimmerSlide} 1.2s ease-in-out infinite;
`;

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const SpinnerIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  animation: ${spin} 2s linear infinite;
`;

export const MinimizedWrapper = styled.div`
  position: fixed;
  bottom: 80px;
  right: 30px;
  display: flex;
  align-items: center;
  gap: 12px;
  z-index: ${CDS_ZINDEX.POP_UP};
`;

export const MinimizedButton = styled.button`
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${Colors.teal500};
  border-radius: 50%;
  border: none;
  cursor: pointer;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);

  &:hover {
    background-color: ${Colors.teal600};
  }
`;
